"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Constants_1 = require("@src/app/commons/Constants");
const DEBUG_1 = require("@src/DEBUG");
DEBUG_1.DEBUG.open('/xs/interfaces/event-listener');
/*
  Create an event listener for any service / helper / controller / whatever
*/
class XsEventListenerInterface {
    constructor() {
        this.__EVENTS = null;
    }
    static __log(i, funcy = '??', data = '') {
        if (XsEventListenerInterface.debug) {
            console.log('%c __LISTENER %c ' + funcy + ' %c ' + i.id + ' ', Constants_1.Constants._red, Constants_1.Constants._black, Constants_1.Constants._gray, data);
        }
    }
    static __init(me) {
        // can't eventify a class with no identity
        if (!me.__ID) {
            console.error('Trying to eventify a class with no identity', me);
            return null;
        }
        // already there?
        if (me.__EVENTS) {
            console.error('Trying to re-eventify an already eventified class', me.__EVENTS);
            return me.__EVENTS;
        }
        // our new events data
        let i = {
            id: me.__ID.id,
            instance: me.__ID.instance,
            introspection: me.__ID.introspection,
            dependants: {},
            subscriptions: [],
            subscription_functions: []
        };
        XsEventListenerInterface.__activate_subscriptions(me, i);
        // register the events and hooks
        XsEventListenerInterface.__registry[i.instance] = i;
        XsEventListenerInterface.__log(i, 'init() DONE');
        return i;
    }
    static __activate_subscriptions(me, config) {
        if (!config) {
            console.error('!!', me, config);
            return null;
        }
        config.introspection.forEach(p => {
            p = ('' + p).trim(); // make sure it's a string
            const first = p.split('(')[0];
            if (p.substring(0, 3) == '___') {
                config.subscription_functions.push(first.substring(3));
            }
            // console.log('!',p, first, first.substring(3) );
        });
        XsEventListenerInterface.__log(config, 'activate_subscriptions()', me);
        // [ config.introspection.length, config.subscription_functions, me.applicationEvents ]
        // we need the applicationEvents service for this part to work (hacky dependency)
        if (me && me.applicationEvents) {
            config.subscription_functions.forEach(f => {
                const token = '___' + f;
                XsEventListenerInterface.__log(config, 'subscribe(' + token + ')');
                config.subscriptions.push(me.applicationEvents.when(f).subscribe(incoming => {
                    XsEventListenerInterface.__log(config, 'trigger(' + token + ')', incoming);
                    me['___' + f](incoming);
                }));
            });
        }
    }
    static __delete_subscriptions(me) {
        let config = me.__EVENTS;
        XsEventListenerInterface.__log(config, 'delete_subscriptions()', config);
        if (config && config.subscriptions && config.subscriptions.length) {
            config.subscriptions.forEach(s => {
                XsEventListenerInterface.__log(config, 'unsubscribe()', s);
                s.unsubscribe();
            });
        }
    }
    static __add(me, key, obj) {
        let config = me.__EVENTS;
        if (config && config.dependants) {
            if (config.dependants[key]) {
                // error; adding an existing
            }
            else {
                config.dependants[key] = true;
                return obj;
            }
        }
        return null;
    }
    static __delete_dependencies(me) {
        let config = me.__EVENTS;
        if (config && config.dependants) {
            config.dependants = {};
        }
    }
    static __destroy(me) {
        XsEventListenerInterface.__delete_subscriptions(me);
        XsEventListenerInterface.__delete_dependencies(me);
    }
}
XsEventListenerInterface.debug = Constants_1.Constants.debug_off;
XsEventListenerInterface.__registry = {};
exports.XsEventListenerInterface = XsEventListenerInterface;
